module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ef-Fb-Gc.eb6e1fa1.png";